var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"el-visor-pdf",staticClass:"_df_custom",attrs:{"webgl":"false","download":"false","source":_vm.source}})
}
var staticRenderFns = []

export { render, staticRenderFns }